import React from 'react';
import {FaUser} from "react-icons/fa6";
import InfoGrid from "../../../../../../components/info-grid/info-grid.jsx";

const OccurrenceAnnotations = ({data}) => {
    const annotations = data.annotations ?? []
    if (!annotations.length || !annotations) return null;

    return (
        <>
            { annotations && (
                <section className="space-y-4! px-5!">
                    <h2 className="w-full rounded-[5px] border border-[#e0e0e0] bg-[#efefef] py-0! text-center text-lg! text-[#4f4f4f] print:text-[19px]! print:break-after-avoid!">
                        ANOTAÇÕES
                    </h2>

                    { annotations.map((item, index) => {

                        const info = [
                            {
                                label: null,
                                children: item?.annotation ? (
                                    <>
                                        <div className="flex items-center justify-between gap-8 w-full">
                                            <div className="text-justify flex-1 min-w-0 text-[14px] print:text-[17px]">
                                                {item.annotation}
                                            </div>

                                            <small className="inline-flex items-center gap-1 max-w-sm break-all text-right text-[12px] print:text-[14px]">
                                                <FaUser className="shrink-0"/> <strong> {item.usernameAdd} ({item.cityAdd}) - {item.date} </strong>
                                            </small>
                                        </div>

                                        { index < annotations.length-1 ? ( <div className="chart-divisor mt-2! -mb-3.75! p-px!"/> ) : null}
                                    </>
                                ) : null,
                                dots: false,
                                span: 3
                            }
                        ];

                        return (
                            <>
                                <InfoGrid key={`${index}`} title={""} items={info} columns={3} labelClassName="text-[#4F4F4F] text-[13px]! print:text-[15px]!" valueClassName={'print:text-[17px]!'} className={'pb-3 px-0!'} contentClassName={'space-y-1'}/>
                            </>
                        )

                    })}
                </section>
            )}
        </>
    );
};

export default OccurrenceAnnotations;